module.exports = __webpack_public_path__ + "eeff1f748dc643e7851ec051ff67c4d0.png";